import { Box, Button, Container, Typography } from "@mui/material";
import { AlertTriangle } from "lucide-react";
import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import { ROUTE } from "../constants/routes";

function errorMessage(error: unknown): string {
  if (isRouteErrorResponse(error)) {
    if (typeof error.data === "string" && error.data) return error.data;
    return error.statusText || `Erro ${error.status}`;
  }
  if (error instanceof Error) return error.message;
  return "Erro inesperado";
}

export function RouteLoadError() {
  const error = useRouteError();
  const navigate = useNavigate();
  const message = errorMessage(error);
  const staleDevModule =
    import.meta.env.DEV && message.includes("dynamically imported module");

  return (
    <Container maxWidth="sm">
      <Box
        component="section"
        role="alert"
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: 2,
          px: 2,
          py: 4,
        }}
      >
        <AlertTriangle size={48} aria-hidden />
        <Typography variant="h5" component="h1">
          Não foi possível carregar esta página
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {staleDevModule
            ? "O servidor de desenvolvimento recusou um arquivo antigo. Recarregar busca a versão atual."
            : "Algo interrompeu o carregamento. Recarregue para tentar de novo."}
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: 1.5,
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            onClick={() => window.location.reload()}
            sx={{ minHeight: 44 }}
          >
            Recarregar
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate(ROUTE.SIGNIN)}
            sx={{ minHeight: 44 }}
          >
            Ir para o login
          </Button>
        </Box>
        {import.meta.env.DEV && message ? (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ fontFamily: "monospace", overflowWrap: "anywhere" }}
          >
            {message}
          </Typography>
        ) : null}
      </Box>
    </Container>
  );
}

export default RouteLoadError;
